import { KoncentroBaseModel } from './koncentro-base.model';

export class Service extends KoncentroBaseModel {
  public id: number;
  public name: string;
  public description: string;
  public service_type_id: number;
  public service_type: string;
  public flg_direct_active: string;
  public flg_direct_active_description?: string;
}

export class ServiceStore extends KoncentroBaseModel {
  public dto: 'ServiceStoreDto';

  public id: number;
  public serviceId: number;
  public storeId: number;
  public dateStart?: string;
  public dateEnd?: string;
}

export class ServiceStoreList extends KoncentroBaseModel {
  public dto: 'ServiceStoreListDto';

  public id: number;
  public service_id: number;
  public store_id: number;
  public store_code: string;
  public store_host_code: string;
  public store_name: string;
  public store_short_name: string;
  public service_name: string;
  public service_description: string;
}



// WEBPACK FOOTER //
// ./src/app/models/service.model.ts